export enum RequiresAttentionReasonEnum {
  FaxFailed = 1,
  IncorrectFaxNumber = 2,
  MissingSignatureOrDate = 3,
  OrderContainsAdditionalInfo = 4,
  CannotMatch = 5,
  Other = 99
}

export const RequiresAttentionReasonOptions = [
{ id: 1, label: 'Fax Failed' },
{ id: 2, label: 'Incorrect Fax Number' },
{ id: 3, label: 'Missing Physician Signature/Date' },
{ id: 4, label: 'Order Contains Add. Info' },
{ id: 5, label: 'Cannot Match' },
{ id: 99, label: 'Other' }
];
